module.exports = __webpack_public_path__ + "static/media/sort-solid.23b9fc6b.svg";